export const BETA = "https://beta.api.geodocs.com.br";
export const PROD = "https://api.geodocs.com.br";
export const DEV = "http://localhost:9091";

export const ROOT = process.env.NODE_ENV === 'production' ? PROD : (process.env.NODE_ENV === 'beta' ? BETA : DEV);

export const MAPSERVER_URL = "https://maps.geodocs.com.br/?";
export const MAPSERVER_ROOT_DIR = "/etc/mapserver/"; 

export const PROXY_MAPSERVER_URL = "https://proxy.maps.geodocs.com.br/service?";



// WEBPACK FOOTER //
// ./src/constants/root.js